<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" @opened="openFun">
    <el-form :model="entity" :rules="rules" ref="flowRef" label-width="120px">
      <el-form-item v-show="false" prop="id">
        <el-input v-model="entity.id"></el-input>
      </el-form-item>
      <el-form-item label="流程名称" prop="name">
        <el-input v-model="entity.name" placeholder="请输入流程名称"></el-input>
      </el-form-item>
      <el-form-item label="流程描述" prop="description">
        <el-input type="textarea" maxlength="255" show-word-limit v-model="entity.description"
                  placeholder="请输入流程描述"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="resetForm('flowRef')">重置</el-button>
      <el-button type="primary" :loading="isLoading" @click="submitForm('flowRef')">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {editFlow} from "@/api/sys/flow/flow"
import {successMsg} from "@/utils/message";

export default {
  name: "editFlow",
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
      default: false
    },
    dataObj: Object
  },
  computed: {
    visible: {
      get: function () {
        return this.dialogVisible
      },
      set: function (val) {
        this.$emit('update:dialogVisible', val)
      }
    }
  },
  data() {
    return {
      title: '新增',
      isLoading: false,
      entity: {
        id: null,
        name: '',
        description: ''
      },
      rules: {
        name: [{required: true, message: '流程名称不能为空', trigger: 'blur'}],
        description: [{required: true, message: '流程描述不能为空', trigger: 'blur'}]
      },
      roleList: [],
      options: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  methods: {
    resetForm(ref) {
      this.$refs[ref].resetFields()
    },
    openFun() {
      this.title = this.dataObj.id ? '编辑' : "新增";
      this.entity = this.dataObj ? this.dataObj : {};
    },
    //  提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          editFlow(this.entity).then(() => {
            successMsg('操作成功')
            this.visible = false
            this.$emit('get-list')
            this.isLoading = false
          }).catch(() => {
            this.isLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
::v-deep .vue-treeselect__control {
  height: 28px;
}

::v-deep .el-form-item__content {
  line-height: 28px;
  font-size: 12px;
}
</style>
